import { Spinner } from '@trp-beacon-ui-kit/react-communication';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import { dispatchPageLoad, displayShortDate } from '../../utils/utils';
import SentZeroState from '../SentZeroState/SentZeroState';
import styles from './Sent.module.scss';

const cx = classnames.bind(styles);

const Sent = ({
  hasTracOnly,
  messages,
  requestStatus,
  transition = () => {}
}) => {
  useEffect(() => {
    dispatchPageLoad('Sent');
  }, []);

  const cleanMessage = (message, createdTimestamp, subject, messageId) => {
    const msg = {
      createdTimestamp,
      messageId,
      subject,
      ...message
    };
    if (createdTimestamp) {
      msg.createdTimestamp = new Date(createdTimestamp).getTime();
    }
    return msg;
  };

  if (messages === undefined || messages === null || requestStatus < 0) {
    return (
      <div className={styles.loader}>
        <Spinner />
      </div>
    );
  }

  return (
    <div className={styles.sent}>
      {messages.length ? (
        messages.map(({ createdTimestamp, messageId, subject, ...message }) => (
          <div
            className={classnames(styles.row, 'row')}
            key={messageId}
            onClick={() =>
              transition('selectSent', {
                selectedMessage: cleanMessage(
                  message,
                  createdTimestamp,
                  subject,
                  messageId
                )
              })
            }
          >
            <div className={`${cx('subject', 'sent-text')} branded-subject`}>
              {subject}
            </div>
            <div className={styles['ie-spacer']} />
            <div className={`${cx('date', 'sent-text')} branded-date`}>
              {displayShortDate(createdTimestamp)}
            </div>
          </div>
        ))
      ) : (
        <SentZeroState hasTracOnly={hasTracOnly} transition={transition} />
      )}
    </div>
  );
};

Sent.propTypes = {
  hasTracOnly: PropTypes.bool,
  messages: PropTypes.arrayOf(PropTypes.object),
  requestStatus: PropTypes.number,
  transition: PropTypes.func
};

export default Sent;
